function initPower(powerObj) {
    window.ax.get('api/authorize/powers/pages?sign=' + window.$gloable.userinfo.sign + '&id=' + powerObj.pageId, { }).then(rsp => {
        let data = rsp.data;
        if (data.code == 1) {
            data = data.data;
            for (let key in data) {
                if (powerObj[key] != undefined) {
                    powerObj[key] = data[key];
                }
            }
        } else {
            //this.$message.error(data.Message);
            console.error(data.message);
        }
    }).catch(err => {
        //this.$message.error('获取权限操作失败');
        console.error(err);
    });
}
export default {
    initPower
}